import {
  Link as GenericLink,
} from "@tellescope/react-components"

// eslint incorrectly thinks this type is unused
// eslint-disable-next-line
import { BasePath } from "../definitions/routes"

export const Link = GenericLink as typeof GenericLink<BasePath>
